/* The app portals its dialog outside the header; share only the field's geometry. */
(() => {
  const field = document.getElementById('header-search');
  if (!field) return;
  const position = () => {
    const { top, left, width } = field.getBoundingClientRect();
    if (!width) return;

    const viewportWidth = document.documentElement.clientWidth;
    const panelWidth = Math.min(790, viewportWidth - 32);
    const panelLeft = Math.max(16, Math.min(left - 44, viewportWidth - panelWidth - 16));
    const style = document.documentElement.style;
    // 20.09.2026: nur schreiben, wenn sich der Wert aendert. position() laeuft bei focusin, resize
    // und scroll; ein setProperty mit demselben Wert macht den Stil trotzdem ungueltig — und weil
    // es an <html> haengt, gilt das fuer das ganze Dokument.
    const setz = (n, v) => { if (style.getPropertyValue(n) !== v) style.setProperty(n, v); };
    setz('--mundizio-autocomplete-top', `${Math.max(16, top)}px`);
    setz('--mundizio-autocomplete-left', `${panelLeft}px`);
    setz('--mundizio-autocomplete-input-width', `${Math.min(width, panelWidth)}px`);
    setz('--mundizio-autocomplete-input-offset', `${Math.max(0, Math.min(left - panelLeft, panelWidth - width))}px`);
  };

  document.addEventListener('focusin', (event) => {
    if (event.target.matches('#header-search, .rcc-dynamic__input')) position();
  }, true);
  window.addEventListener('resize', position, { passive: true });
  window.addEventListener('scroll', position, { passive: true });
  new ResizeObserver(position).observe(field);
  position();
})();
